import {TruffleFound} from './truffelFound.model';

export class Tree {
  id: number;
  treeType: string;
  truffleType: string;
  createdAt: string = new Date().toString();
  truffleFounds: TruffleFound[] = [];
  sponsor: any; // must be any and not Sponsor for stupid firebase
  sponsorSince?: string;
}
